import { numberWithCommas, roundNumber, formatDate } from '../../util/functions';

const addCommasToData = (data) => {
  if (undefined !== data.value) {
    return numberWithCommas(data.value);
  }
  return 0;
};

const formatTradeDate = (data) => {
  if (undefined !== data.value) {
    return formatDate(data.value, 'YYYY-MM-DD', 'MM/DD/YYYY');
  }
  return '-';
};

export const addCommasToNotional = (data) => {
  if (undefined !== data.value) {
    return numberWithCommas(roundNumber(data.value, 0));
  }
  return 0;
};

export const skuSummaryDataColumns = [
  {
    dataField: 'mpid',
    caption: 'MPID',
    groupIndex: 0,
    autoExpandGroup: false
  },
  {
    dataField: 'sku',
    caption: 'SKU'

  },
  {
    dataField: 'trades',
    caption: 'Trades',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'volume',
    caption: 'Volume',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'
  },
  {
    dataField: 'notional',
    caption: 'Notional',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  }
];
export const dailySummaryDataColumns = [
  {
    dataField: 'tradeDate',
    caption: 'Date',
    customizeText: formatTradeDate

  },
  {
    dataField: 'trades',
    caption: 'Trades',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'volume',
    caption: 'Volume',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'
  },
  {
    dataField: 'notional',
    caption: 'Notional',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  }

];

export const venueRangeSummaryDataColumns = [
  {
    dataField: 'tradeDate',
    caption: 'Date',
    customizeText: formatTradeDate

  },
  {
    dataField: 'arcaTrades',
    caption: 'ARCA Trades',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'arcaVolume',
    caption: 'ARCA Volume',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'
  },
  {
    dataField: 'arcaNotional',
    caption: 'ARCA Notional',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'
  },
  {
    dataField: 'cicfTrades',
    caption: 'CICF Trades',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'cicfVolume',
    caption: 'CICF Volume',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'
  },
  {
    dataField: 'cicfNotional',
    caption: 'CICF Notional',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'ecnTrades',
    caption: 'ECN Trades',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'ecnVolume',
    caption: 'ECN Volume',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'
  },
  {
    dataField: 'ecnNotional',
    caption: 'ECN Notional',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'idqsTrades',
    caption: 'IDQS Trades',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'idqsVolume',
    caption: 'IDQS Volume',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'
  },
  {
    dataField: 'idqsNotional',
    caption: 'IDQS Notional',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'atsTrades',
    caption: 'ATS Trades',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'atsVolume',
    caption: 'ATS Volume',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'
  },
  {
    dataField: 'atsNotional',
    caption: 'ATS Notional',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'totalTrades',
    caption: 'Total Trades',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'totalVolume',
    caption: 'Total Volume',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'
  },
  {
    dataField: 'totalNotional',
    caption: 'Total Notional',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  }
];

export const venueSummaryDataColumns = [
  {
    dataField: 'venue',
    caption: 'Venue'
  },
  {
    dataField: 'trades',
    caption: 'Trades',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'volume',
    caption: 'Volume',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'
  },
  {
    dataField: 'notional',
    caption: 'Notional',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  }
];

export const symbolSummaryDataColumns = [
  {
    dataField: 'security',
    caption: 'Symbol'
  },
  {
    dataField: 'trades',
    caption: 'Trades',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  },
  {
    dataField: 'volume',
    caption: 'Shares',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'
  },
  {
    dataField: 'notional',
    caption: 'Notional',
    customizeText: addCommasToData,
    alignment: 'right',
    dataType: 'number'

  }
];

export const firmSummaryDataColumns = [
  {
    dataField: 'firm',
    caption: 'Firm'
  },
  {
    caption: 'Total',
    columns: [
      {
        dataField: 'totalTrades',
        caption: 'Trades',
        customizeText: addCommasToData,
        alignment: 'right',
        dataType: 'number'

      },
      {
        dataField: 'totalVolume',
        caption: 'Volume',
        customizeText: addCommasToData,
        alignment: 'right',
        dataType: 'number'
      },
      {
        dataField: 'totalNotional',
        caption: 'Notional',
        customizeText: addCommasToNotional,
        alignment: 'right',
        dataType: 'number'

      } ]
  },
  {
    caption: '>=$1',
    columns: [
      {
        dataField: 'aboveTrades',
        caption: 'Trades',
        customizeText: addCommasToData,
        alignment: 'right',
        dataType: 'number'

      },
      {
        dataField: 'aboveVolume',
        caption: 'Volume',
        customizeText: addCommasToData,
        alignment: 'right',
        dataType: 'number'
      },
      {
        dataField: 'aboveNotional',
        caption: 'Notional',
        customizeText: addCommasToNotional,
        alignment: 'right',
        dataType: 'number'

      }]
  },
  {
    caption: '< $1 >= .01',
    columns: [
      {
        dataField: 'betweenTrades',
        caption: 'Trades',
        customizeText: addCommasToData,
        alignment: 'right',
        dataType: 'number'

      },
      {
        dataField: 'betweenVolume',
        caption: 'Volume',
        customizeText: addCommasToData,
        alignment: 'right',
        dataType: 'number'
      },
      {
        dataField: 'betweenNotional',
        caption: 'Notional',
        customizeText: addCommasToNotional,
        alignment: 'right',
        dataType: 'number'

      }]
  },
  {
    caption: '< .01',
    columns: [
      {
        dataField: 'belowTrades',
        caption: 'Trades',
        customizeText: addCommasToData,
        alignment: 'right',
        dataType: 'number'

      },
      {
        dataField: 'belowVolume',
        caption: 'Volume',
        customizeText: addCommasToData,
        alignment: 'right',
        dataType: 'number'
      },
      {
        dataField: 'belowNotional',
        caption: 'Notional',
        customizeText: addCommasToNotional,
        alignment: 'right',
        dataType: 'number'

      }]
  }

];
